import { Admin, ButtonStyled, EventButtonStyled, Inverted } from "./button.styles.jsx";

export const BUTTON_TYPE_CLASSES = {
    base: 'base',
    eventButton: 'event',
    inverted: 'inverted',
    admin: 'admin',
}

const getButton = (buttonType = BUTTON_TYPE_CLASSES.base) => (
    {
        [BUTTON_TYPE_CLASSES.base]: ButtonStyled,
        [BUTTON_TYPE_CLASSES.eventButton]: EventButtonStyled,
        [BUTTON_TYPE_CLASSES.inverted]: Inverted,
        [BUTTON_TYPE_CLASSES.admin]: Admin,
    }[buttonType]
)

const Button = ({children, link, buttonType, buttonClass, onClick}) => {
    const CustomButton = getButton(buttonType);
    return (
        <>
            <CustomButton className={buttonClass} to={link} target="_top" onClick={onClick}>
                {children}  
                <span className="btn__arrow">
                    <i className="fa-solid fa-arrow-right"></i>
                </span>
            </CustomButton>
        </>
    ) 
}

export default Button;